export const GLOBAL_STATE = 'ModuleFiles'

export const POLICIES_ALL = 'POLICIES_ALL' as const
export const MODULE_FILE = 'MODULE_FILE' as const
export const MODULE_FILE_CREATE = 'MODULE_FILE_CREATE' as const
export const MODULE_FILE_DELETE = 'MODULE_FILE_DELETE' as const
export const MODULE_FILE_LIST = 'MODULE_FILE_LIST' as const
export const MODULE_FILE_ALL = 'MODULE_FILE_ALL' as const
